'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('weex-bindingx/lib/index.weex');

var _index2 = _interopRequireDefault(_index);

var _bindEnv = require('../utils/bind-env');

var _bindEnv2 = _interopRequireDefault(_bindEnv);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');

// 减少打包体积


var ICON_ARROW_DOWN = 'https://img.alicdn.com/tfs/TB1A8faeTtYBeNjy1XdXXXXyVXa-48-48.png';

exports.default = {
  props: {
    scrollerRef: String,
    maxTime: {
      type: Number,
      default: 0
    },
    mainText: {
      type: String,
      default: ''
    },
    pullingText: {
      type: String,
      default: ''
    },
    refreshingText: {
      type: String,
      default: ''
    },
    textWidth: {
      type: Number,
      default: 200
    }
  },
  data: function data() {
    return {
      ICON_ARROW_DOWN: ICON_ARROW_DOWN,
      refreshing: false,
      couldUnLash: false,
      loadingIcon: 'http://dolphin-weex-dev.msmartlife.cn/cdn/images/common/loading_gray.png'
    };
  },

  computed: {
    newStyleFlag: function newStyleFlag() {
      return this.scrollerRef && _bindEnv2.default.supportsEBForIos();
    },
    refresherText: function refresherText() {
      return this.refreshing ? this.refreshingText : this.pText;
    },
    pText: function pText() {
      return this.couldUnLash ? this.pullingText : this.mainText;
    }
  },
  created: function created() {
    this.newStyleFlag && this.animationBinding();
  },
  beforeDestroy: function beforeDestroy() {
    this.bindingsDestroy();
  },

  methods: {
    onRefresh: function onRefresh(event) {
      var _this = this;

      this.$emit('dofRefresh', event);
      this.refreshing = true;
      this.newStyleFlag && this.cycleGoRound();
      if (this.maxTime <= 0) return;
      this.timeoutSto && clearTimeout(this.timeoutSto);
      this.timeoutSto = setTimeout(function () {
        _this.$emit('dofTimeout');
        _this.dofCancel();
      }, this.maxTime);
    },

    /**
     * 取消 refreshing
     */
    dofCancel: function dofCancel() {
      this.refreshing = false;
      this.timeoutSto && clearTimeout(this.timeoutSto);
      this.roundingDestroy();
    },

    /**
     * 下拉事件
     */
    onPullingDown: function onPullingDown(event) {
      this.$emit('dofPullingDown', event);
      var pd = event.pullingDistance * (_utils2.default.env.isIOS() ? -1 : 1);
      pd > (_utils2.default.env.isAndroid() ? 200 : 140) ? this.couldUnLash = true : this.couldUnLash = false;
      if (this.refreshing && pd < 20) {
        this.timeoutSto && clearTimeout(this.timeoutSto);
        this.refreshing = false;
        this.roundingDestroy();
      }
    },

    /**
     * 注册 bindingx
     */
    animationBinding: function animationBinding() {
      var _this2 = this;

      setTimeout(function () {
        if (!_this2.$refs['cover2'] || !_this2.$refs['cover-cycle']) return;
        // 降级版本取不到，需要注意
        var scroller = _this2.$parent.$refs[_this2.scrollerRef].ref;
        var cover2 = _this2.$refs['cover2'].ref;
        var coverCycle = _this2.$refs['cover-cycle'].ref;

        var bindingResult = _index2.default.bind({
          eventType: 'scroll',
          anchor: scroller,
          props: [{
            element: cover2,
            property: 'transform.rotateZ',
            expression: 'y>-140?(y%75/150*-360):156'
          }, {
            element: coverCycle,
            property: 'opacity',
            expression: 'y<-75 ?1:0'
          }]
        }, function (e) {});
        _this2.bindingToken = bindingResult.token;
      }, 300);
    },

    /**
     * 旋转动作
     */
    cycleGoRound: function cycleGoRound() {
      if (_utils2.default.env.isAndroid()) return;
      if (!this.$refs['cycle']) return;
      var cycle = this.$refs['cycle'].ref;
      this.arrowShow(false);
      if (!cycle) {
        return;
      }
      var roundingResult = _index2.default.bind({
        eventType: 'timing',
        props: [{
          element: cycle,
          property: 'transform.rotateZ',
          expression: 't*0.72'
        }]
      }, function (e) {});
      this.roundingToken = roundingResult.token;
    },

    /**
     * 箭头显隐控制
     */
    arrowShow: function arrowShow() {
      var _show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var arrow = this.$refs['arrow'];
      arrow && animation.transition(arrow, {
        styles: {
          opacity: _show ? 1 : 0,
          transform: _show ? 'scale(1)' : 'scale(0.5)'
        },
        duration: 300,
        delay: 0
      }, function () {});
    },

    /**
     * 完整 bindingx 销毁
     */
    bindingsDestroy: function bindingsDestroy() {
      if (this.bindingToken !== 0) {
        _index2.default && _index2.default.unbind({
          eventType: 'scroll',
          token: this.bindingToken
        });
        this.bindingToken = 0;
      }
      this.roundingDestroy();
    },

    /**
     * 旋转 bindingx 销毁
     */
    roundingDestroy: function roundingDestroy() {
      if (this.roundingToken !== 0) {
        _index2.default && _index2.default.unbind({
          eventType: 'timing',
          token: this.roundingToken
        });
        this.roundingToken = 0;
      }
      this.arrowShow(true);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-refresher/index.vue
// module id = 378
// module chunks = 0 1